export default __webpack_public_path__ + "static/media/logoMain.b9b7b58e.png";